import React from "react";
import HomePageStore from "../HomePageStore";
import { observer, inject } from "mobx-react";
import { formatMoney } from "accounting";
import { HomePageVariant } from "../models/HomePageModel";
import Repayment from "../../Repayments/Repayment";
import ImgLazyLoad from "../../ImgLazyLoad";

export interface DiscoverAndBuildItemsProps {}

interface InjectedProps extends DiscoverAndBuildItemsProps {
  homePageStore: HomePageStore;
}
const discoverAndBuildItems: React.SFC<DiscoverAndBuildItemsProps> = (
  props
) => {
  const { homePageStore } = props as InjectedProps;
  return (
    homePageStore.homePageContent.response.discoverAndBuild[
      homePageStore.selectedTab
    ] && (
      <div className="subaru_tab_content">
        <div className="subaru_title">
          <p>
            DISCOVER AND BUILD OUR{" "}
            <strong>{homePageStore.selectedTabTitle}</strong> RANGE
          </p>
        </div>
        <div className="subaru_discover_items">
          {homePageStore.homePageContent.response.discoverAndBuild[
            homePageStore.selectedTab
          ].map((item: HomePageVariant, i) => {
            return (
              <div className="subaru_items_details" key={i}>
                <div className="subaru_image_wrapper">
                  <ImgLazyLoad src={item.homepageVariantImage} />
                </div>
                <div className="title">
                  <h3>
                    <ImgLazyLoad src={item.homepageModelBadge} />
                  </h3>
                </div>
                <div className="detail_content">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.homepageModelBlurb,
                    }}
                  />
                  <p className="price_show">{item.homepageModelDisclaimer}</p>
                  {item.displayVariantPrice && (
                    <div className="discover__pricing">
                      <span className="modelWalk__pricing-from">From</span>
                      <p className="Price">
                        {item.price &&
                          formatMoney(item.price, {
                            symbol: "$",
                            precision: 0,
                          })}
                      </p>
                      <div className="modelWalk__detailedLink">
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            homePageStore.showDetailedPricing(item);
                          }}
                        >
                          Recommended Driveaway Price
                          <i className="icon icon--info" />
                        </a>
                      </div>
                    </div>
                  )}

                  <Repayment
                    pimIdentifier={item.pimIdentifier}
                    rdp={item.price}
                  ></Repayment>
                </div>
                <div className="cta_wrapper">
                  {!!item.homepageLink1 && !!item.homepageLink1Text && (
                    <a href={item.homepageLink1}>{item.homepageLink1Text}</a>
                  )}

                  {!!item.homepageLink2 && !!item.homepageLink2Text && (
                    <a href={item.homepageLink2} className="subaru_build_cta">
                      {item.homepageLink2Text}
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    )
  );
};

export default inject("homePageStore")(observer(discoverAndBuildItems));
